import { render } from "./HomeOwnershipPage.vue?vue&type=template&id=052bd26c&scoped=true"
import script from "./HomeOwnershipPage.vue?vue&type=script&lang=js"
export * from "./HomeOwnershipPage.vue?vue&type=script&lang=js"

import "./HomeOwnershipPage.vue?vue&type=style&index=0&id=052bd26c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052bd26c"]])

export default __exports__